import { useDispatch, useSelector } from "react-redux";
import { hideModal } from "../services/actions";
import DeleteUserConfirmation from "./DeleteUserConfirmation";
import EditEmail from "./EditEmail";
import EditUserProfile from "./EditUserProfile";
import RevokeConfirmation from "./RevokeConfirmation";

function ModalContainer() {
  const { visible, props } = useSelector((state) => state.modal);
  const dispatch = useDispatch();

  const onClose = () => {
    const url = new URL(window.location.href);
    url.searchParams.delete("modal");
    window.history.replaceState({}, document.title, url.toString());
    props?.revalidator?.revalidate?.();
    props?.onCloseEnd?.();

    dispatch(hideModal());
  };

  return (
    <div>
      {visible && <style>{"html,body {overflow-y:hidden}"}</style>}

      <RevokeConfirmation visible={visible === "revokeConfirmation"} onClose={onClose} {...props} />
      <DeleteUserConfirmation visible={visible === "deleteUserConfirmation"} onClose={onClose} {...props} />
      <EditUserProfile visible={visible === "editUserProfile"} onClose={onClose} {...props} />
      <EditEmail visible={visible === "editEmail"} onClose={onClose} {...props} />
    </div>
  );
}

export default ModalContainer;
